import axios from "axios";

export const axiosS3 = axios.create();
delete axiosS3.defaults.headers.common["Authorization"];
